import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MenuService } from '../core/menu/menu.service';
import { SharedModule } from '../shared/shared.module';
import { PagesModule } from './pages/pages.module';
import { QuestionnaireResultModule } from './questionnaire-result/questionnaire-result.module';

import { getMenu } from './menu';
import { routes } from './routes';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from './user/user.service';

//import { routes, ROUTES_PROVIDERS } from './routes';


@NgModule({
    imports: [
        SharedModule,
        RouterModule.forRoot(routes),
        PagesModule,
        QuestionnaireResultModule
    ],
    declarations: [],
    exports: [
        RouterModule
    ],
})

export class RoutesModule {
    constructor(
        private menuService: MenuService,
        private translateService: TranslateService,
        private userService: UserService
    ) {
        menuService.addMenu(getMenu());
    }
}
